import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { env } from '@/config/env';

// Client Supabase autonome — pointe vers la nouvelle instance
// Utilise les variables validées par Zod (voir src/config/env.ts)
export const supabase = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      storageKey: 'visionpos-auth',
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);

// Client legacy (optionnel) — pour la migration de données uniquement
export const legacySupabase =
  env.VITE_LEGACY_SUPABASE_URL && env.VITE_LEGACY_SUPABASE_KEY
    ? createClient<Database>(env.VITE_LEGACY_SUPABASE_URL, env.VITE_LEGACY_SUPABASE_KEY, {
        auth: {
          storage: localStorage,
          persistSession: false,
          autoRefreshToken: false,
        },
      })
    : null;
